/**
 * Inline style objects for content components (originally from vanilla-extract style exports).
 * These are passed to components via the style prop, not as className.
 */

/** Title style for F0Text in content blocks (quiz, video, etc.) */
export const titleStyle = {
  fontSize: '2.5rem',
  fontWeight: 600,
  lineHeight: 1.3,
} as const
